'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExperimentVariation = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CmsModules = require('containers/CmsPage/CmsModules');

var _optimizely = require('helpers/optimizely');

var Optimizely = _interopRequireWildcard(_optimizely);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperimentVariation = exports.ExperimentVariation = function (_PureComponent) {
  (0, _inherits3.default)(ExperimentVariation, _PureComponent);

  function ExperimentVariation() {
    (0, _classCallCheck3.default)(this, ExperimentVariation);
    return (0, _possibleConstructorReturn3.default)(this, (ExperimentVariation.__proto__ || (0, _getPrototypeOf2.default)(ExperimentVariation)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExperimentVariation, [{
    key: 'shouldRender',
    value: function shouldRender() {
      var _props = this.props,
          experimentId = _props.experimentId,
          isDefault = _props.isDefault,
          variationId = _props.variationId;


      return Optimizely.isActiveExperimentById(experimentId) ? Optimizely.isActiveVariationById(experimentId, variationId) : isDefault;
    }
  }, {
    key: 'render',
    value: function render() {
      var modules = this.props.modules;


      return this.shouldRender() ? _react2.default.createElement(_CmsModules.CmsModules, { modules: modules }) : null;
    }
  }]);
  return ExperimentVariation;
}(_react.PureComponent);

ExperimentVariation.propTypes = {
  experimentId: _propTypes2.default.string.isRequired,
  isDefault: _propTypes2.default.bool,
  modules: _propTypes2.default.array.isRequired,
  variationId: _propTypes2.default.string.isRequired
};